<template>
    <v-navigation-drawer
        width="400"
        location="right"
        class="tw-select-none tw-bg-gray-100 tw-p-10 tw-pt-12"
        floating
        v-model="modelValue">
        <div class="tw-flex tw-flex-col tw-gap-4">
            <div class="tw-flex tw-items-center tw-justify-between">
                <h1 class="tw-text-xl tw-font-semibold">{{ $t('fields.devices') }}</h1>
                <v-btn
                    @click="modelValue = false"
                    color="gray-300"
                    density="comfortable"
                    class="rounded-lg tw-text-dark tw-shadow-none"
                    icon="mdi-close"></v-btn>
            </div>
        </div>
        <!-- grid of 2 columns -->
        <div
            v-if="blueprintStore.getDevicesForSidebar.length"
            class="tw-mt-4 tw-grid tw-grid-cols-2 tw-gap-4">
            <CardDevice
                v-for="device in blueprintStore.getDevicesForSidebar"
                :device="device"
                @dragstart="onDragStart"
                :key="device.id"></CardDevice>
        </div>
        <div
            v-else
            class="tw-mt-4">
            <p class="tw-text-center">{{ $t('views.floors.noDevicesToInstall') }}</p>
        </div>
    </v-navigation-drawer>
</template>

<script setup lang="ts">
    import CardDevice from './CardDevice.vue';
    import { useBlueprintStore } from '@/store/blueprint';

    const modelValue = defineModel({
        default: false,
    });
    const blueprintStore = useBlueprintStore();

    function onDragStart() {
        // if screen width is less than 640px, close the sidebar
        if (window.innerWidth < 640) {
            modelValue.value = false;
        }
    }
</script>

<style scoped></style>
